import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import OneLineCardSkeleton from "../../components/SkeletonCards/OneLineCardSkeleton";
import useFetch from "../../hooks/useFetch";
import PerformanceCard from "../../components/PerformanceCard";
import EntityAddUpdateForm from "../../components/EntityAddUpdateForm/EntityAddUpdateForm";
import { FileDownload } from '@mui/icons-material';
//import {Buffer} from 'buffer';
//window.Buffer = window.Buffer || require("buffer").Buffer;
import { Buffer } from 'buffer'; if (!window.Buffer) {   window.Buffer = Buffer; }

import SelectInput from "../../components/ui/Input/SelectInput";
import TextInput from "../../components/ui/Input/TextInput";
import { toast } from "react-toastify";
import { useRef } from 'react';
import TagInput from "../../components/ui/Input/TagInput";
import "./SongSelect.css";
import SongSelect from "../../components/Music/SongsSelect";

import ConfirmActionDialog from "./ConfirmActionDialog";

const AdminPerformances: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams<{ event_id: string }>();
  const event_id = params?.event_id;
  const [selectedFile, setSelectedFile] = useState<File | null>(null);  
  const [isUploadingCsv, setIsUploadingCsv] = useState<boolean>(false);

  const [songId, setSongId] = useState<number | null>(null);
  const [songs, setSongs] = useState<any[]>([]);

  const [selectedEventId, setSelectedEventId] = useState<string>("");
  const [selectedCompetitionId, setSelectedCompetitionId] = useState<string>("");

  const [selectedType, setSelectedType] = useState("TWD");
  const [selectedSubType, setSelectedSubType] = useState("");
  
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [succesPerformanceCount, setSuccesPerformanceCount] =
    useState<number>(0);
  const [successPerformances, setSuccessPerformances] = useState<string | null>(
    null
  );
  const [failedPerformanceCount, setFailedPerformanceCount] =
    useState<number>(0);
  const [failedPerformances, setFailedPerformances] = useState<string | null>(
    null
  );
  const [showResponsePopup, setShowResponsePopup] = useState(false);

  const [confirmDialog, setConfirmDialog] = useState<{
    open: boolean;
    action: "add" | "edit" | "delete";
    entryNumber?: number | string;
    meta?: object;
    onConfirm: () => void;
  }>({ open: false, action: "add", onConfirm: () => {} });

  const [showPerformanceForm, setShowPerformanceForm] = useState<boolean>(false);
  interface AddEditPerformanceData {
    isNew: boolean;
    performance_id: number;
    performance_type: string;
    performance_time: string;
    divisions_performance_groups_id: number;
    event_id: number;
    entry_number: number;
    user_programdirector_id: number;
    playlist_number: string;
    description: string;
    performers_count: string;
    grade: string;
    level: string;
    routine: string;
    style: string;
    class: string;
    performerslist: string;
    performerslistArr: string[];
    song_id: number | null;
  }
  const resetPerformanceData = {
    isNew: true,
    performance_id: 0,
    performance_type: '',
    performance_time: '00:00',
    divisions_performance_groups_id: 0,
    event_id: Number(event_id),
    entry_number: 0,
    user_programdirector_id: 0,
    playlist_number: '',
    description: '',
    performers_count: '',
    grade: '',
    level: '',
    routine: '',
    style: '',
    class: '',
    performerslist: '',
    performerslistArr: [],
    song_id: 0
  };
  const [initialPerformanceData, setInitialPerformanceData] = useState<AddEditPerformanceData>(resetPerformanceData);
  const [newPerformanceData, setNewPerformanceData] = useState<AddEditPerformanceData>(resetPerformanceData);
  const [performancePerformers, setPerformancePerformers] = useState<string[]>([]);
  useEffect(() => {
    setNewPerformanceData((prev) => ({
      ...prev,
      performerslistArr: performancePerformers,
      performerslist: performancePerformers.join(', '),
    }))
  }, [performancePerformers, setPerformancePerformers]);
  
  const myRef = useRef<HTMLElement | null>(null);
  const showEditPerformanceForm = async (pid:number, entryid:string, pdivision:number, routine:string, user_programdirector_id:number, ptime: string, performers: string, playlist_number: string, style: string, pclass: string, grade: string, level: string, performer_count: string, description: string, performance_type: string, song_id:number, event_id:number) => {
    let sHours =""; let minutes = ""; let period = "";
    const matchptime = ptime?.match(/([0-9]{1,2}):([0-9]{2}) (AM|PM)/);
    if ( matchptime) {
      [sHours, minutes, period] = matchptime.slice(1);
    }
    const PM = period === 'PM';
    const hours = (+sHours % 12) + (PM ? 12 : 0);
    const time = `${('0' + hours).slice(-2)}:${minutes}`;
    const getData = {
      isNew: false,
      performance_id: pid,
      performance_type: performance_type,
      performance_time: time,
      divisions_performance_groups_id: pdivision,
      event_id: Number(event_id),
      entry_number: Number(entryid),
      user_programdirector_id: user_programdirector_id,
      playlist_number: playlist_number,
      description: description,
      performers_count: performer_count,
      grade: grade,
      level: level,
      routine: routine,
      style: style,
      class: pclass,
      performerslist: performers,
      performerslistArr: performers.split(', '),
      song_id: song_id,
    };
    setShowPerformanceForm(true);
    setNewPerformanceData(getData);
    setInitialPerformanceData(getData);
    setSongId((song_id));

    setTimeout(() => {
    myRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    }, 100);
  };
  const AddPerformanceForm = async () => {
    let indata = resetPerformanceData;
    indata.performance_type = performances?.eventDetails?.performance_type;
    setNewPerformanceData(indata);
    setInitialPerformanceData(indata);
    setShowPerformanceForm(true);
    setSongId(null);
    myRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleEditPerformance = async (e: React.FormEvent) => {
    //console.log("InitialPerformanceData: ", initialPerformanceData);
    //console.log("NewPerformanceData: ", newPerformanceData);
    try {
      e.preventDefault();
      if(initialPerformanceData === newPerformanceData){
        alert('No change in fields');
        return false;
      }
        const _divId = newPerformanceData.divisions_performance_groups_id;
        const _divStatus = performances?.performances?.find((p: any) => p.divisions_performance_group?.id === _divId)?.divisions_performance_group?.status
        ?? performances?.divisionlist?.find((d: any) => d.id === _divId)?.status;
        const _divName = performances?.divisionlist?.find((d: any) => d.id === _divId)?.title
          ?? performances?.performances?.find((p: any) => p.divisions_performance_group?.id === _divId)?.divisions_performance_group?.title;
        const _oldDivId = initialPerformanceData.divisions_performance_groups_id;
        const _oldDivStatus = performances?.performances?.find((p: any) => p.divisions_performance_group?.id === _oldDivId)?.divisions_performance_group?.status
        ?? performances?.divisionlist?.find((d: any) => d.id === _oldDivId)?.status;
        const _oldDivName = performances?.divisionlist?.find((d: any) => d.id === _oldDivId)?.title;
        const _oldProgram = performances?.directorlist?.find((d: any) => d.id === initialPerformanceData.user_programdirector_id)?.first_name;
        const _newProgram = performances?.directorlist?.find((d: any) => d.id === newPerformanceData.user_programdirector_id)?.first_name;
        
        await new Promise<void>((resolve) => {
          setConfirmDialog({
            open: true,
            action: newPerformanceData.isNew ? "add" : "edit",
            entryNumber: newPerformanceData.entry_number,
            meta: {
              divisionStatus: _divStatus,
              oldDivisionName: _oldDivName,
              newDivisionName: _divName,
              oldProgramName: _oldProgram,
              newProgramName: _newProgram,
              oldDivisionStatus: _oldDivStatus,
            },
            onConfirm: () => { setConfirmDialog(p => ({ ...p, open: false })); resolve(); },
          });
        });
        if (true) {
        const token = localStorage.getItem("token");
        let pData = {};
        pData = { ...pData, event_id: newPerformanceData.event_id };
        pData = { ...pData, divisions_performance_groups_id: newPerformanceData.divisions_performance_groups_id };
        //console.log("old pData: ", pData);
        if(initialPerformanceData.entry_number !== newPerformanceData.entry_number || newPerformanceData.isNew)
          pData = { ...pData, entry_number: newPerformanceData.entry_number };
        if(initialPerformanceData.performance_time !== newPerformanceData.performance_time || newPerformanceData.isNew)
          pData = { ...pData, performance_time: newPerformanceData.performance_time };
        if(initialPerformanceData.user_programdirector_id !== newPerformanceData.user_programdirector_id || newPerformanceData.isNew)
          pData = { ...pData, user_programdirector_id: newPerformanceData.user_programdirector_id };
        if(initialPerformanceData.playlist_number !== newPerformanceData.playlist_number || newPerformanceData.isNew)
          pData = { ...pData, playlist_number: newPerformanceData.playlist_number };
        //if(initialPerformanceData.description !== newPerformanceData.description || newPerformanceData.isNew)
          pData = { ...pData, description: newPerformanceData.description };
        if(initialPerformanceData.performers_count !== newPerformanceData.performers_count || (newPerformanceData.isNew && newPerformanceData.performance_type==='twd'))
          pData = { ...pData, performers_count: newPerformanceData.performers_count };
        if(initialPerformanceData.grade !== newPerformanceData.grade || (newPerformanceData.isNew && newPerformanceData.performance_type==='sds'))
          pData = { ...pData, grade: newPerformanceData.grade };
        if(initialPerformanceData.level !== newPerformanceData.level || (newPerformanceData.isNew && newPerformanceData.performance_type==='sds'))
          pData = { ...pData, level: newPerformanceData.level };
        if(initialPerformanceData.routine !== newPerformanceData.routine || newPerformanceData.isNew)
          pData = { ...pData, routine: newPerformanceData.routine };
        //if(initialPerformanceData.style !== newPerformanceData.style || (newPerformanceData.isNew && newPerformanceData.performance_type==='twd'))
        
        pData = { ...pData, style: newPerformanceData.style };
        //if(initialPerformanceData.class !== newPerformanceData.class || (newPerformanceData.isNew && newPerformanceData.performance_type==='twd'))
        pData = { ...pData, class: newPerformanceData.class };
        
        if(initialPerformanceData.performerslist !== newPerformanceData.performerslist || (newPerformanceData.isNew && newPerformanceData.performance_type==='sds'))
          pData = { ...pData, performerslist: newPerformanceData.performerslist };
        
        pData = { ...pData, song_id: newPerformanceData.song_id, old_song_id: initialPerformanceData.song_id, };

        const selectedProgram = performances?.directorlist?.find(
          (div: any) => div.id === newPerformanceData.user_programdirector_id
        );
        const selectedProgramLabel = selectedProgram?.first_name || '';
        pData = { ...pData, selectedProgramLabel: selectedProgramLabel };

        const divisionStatusData = {
          divisions_performance_groups_ids: [] as number[],
          divisions_titles_map: {} as Record<number, string>,
          performance_subtype: performances?.eventDetails?.performance_subtype || "",
          performance_type: performances?.eventDetails?.performance_type || "",
          new_division_status: _divStatus || "judging",
          old_division_status: _oldDivStatus || "judging",
          action: ""
        };

        if (newPerformanceData.isNew) {
          const divId = newPerformanceData.divisions_performance_groups_id;
          const divStatus = performances?.divisionlist?.find((d: any) => d.id === divId)?.status;
          if (divStatus !== "judging") {
            divisionStatusData.divisions_performance_groups_ids = [divId];
            divisionStatusData.divisions_titles_map[divId] = performances?.divisionlist?.find((d: any) => d.id === divId)?.title || String(divId);
            divisionStatusData.action = "new_entry";
          }
        } else {
          const divisionChanged = initialPerformanceData.divisions_performance_groups_id !== newPerformanceData.divisions_performance_groups_id;
          const directorChanged = initialPerformanceData.user_programdirector_id !== newPerformanceData.user_programdirector_id;

          if (divisionChanged) {
            const oldDivId = initialPerformanceData.divisions_performance_groups_id;
            const newDivId = newPerformanceData.divisions_performance_groups_id;
            const oldDivStatus = performances?.divisionlist?.find((d: any) => d.id === oldDivId)?.status;
            if (oldDivStatus !== "judging") {
              divisionStatusData.divisions_performance_groups_ids.push(oldDivId);
              divisionStatusData.divisions_titles_map[oldDivId] = performances?.divisionlist?.find((d: any) => d.id === oldDivId)?.title || String(oldDivId);
            }
              divisionStatusData.divisions_performance_groups_ids.push(newDivId);
              divisionStatusData.divisions_titles_map[newDivId] = performances?.divisionlist?.find((d: any) => d.id === newDivId)?.title || String(newDivId);
          } else if (directorChanged) {
            const divId = newPerformanceData.divisions_performance_groups_id;
            const divStatus = performances?.divisionlist?.find((d: any) => d.id === divId)?.status;
            if (divStatus !== "judging") {
              divisionStatusData.divisions_performance_groups_ids = [divId];
              divisionStatusData.divisions_titles_map[divId] = performances?.divisionlist?.find((d: any) => d.id === divId)?.title || String(divId);
            }
          }
        }

        pData = { ...pData, divisionStatusData: divisionStatusData };

        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/performances/add-update-byadmin/${newPerformanceData.performance_id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(pData),
          }
        );
        const result = await response.json();
  
        if (response.ok) {
          setShowPerformanceForm(false);
          fetchData();
          const updateMsg = (newPerformanceData.isNew) ? `New entry added successfully.` : `Entry #${newPerformanceData.entry_number} updated successfully.`;
          toast.info(updateMsg);
          setNewPerformanceData(resetPerformanceData);
          setInitialPerformanceData(resetPerformanceData);
        } else {
         console.log('p reror', result);
         if(result?.error?.message){
          let tostError = [];
          if(Array.isArray(result.error.message)) tostError = result.error.message;
          else tostError.push(result.error.message);
          tostError[tostError.indexOf('Fields entry_number, event_id must be unique')] = 'Entry Number must be unique.';
          tostError.map((msg: any) => (  toast.warn(msg) ));
         }else{
          /*toast.warn(
            result?.message?.trim()
              ? `Server Error! ${result.message}`
              : 'Server Error!'
          );*/
          const missingSummary = result?.data?.missing_scores_summary;
          const missingSummaryHtml = missingSummary?.length
            ? `<br/><br/><strong>Missing scores:</strong><br/>` + missingSummary.join('<br/>')
            : '';

          toast.warn(
              <div dangerouslySetInnerHTML={{ __html: `Server Error! ${result.message}${missingSummaryHtml}` }} />
            );
         }
        }
      }else{
        console.log('cancel');
      }
    } catch (err) {
      console.warn(err);
    }
  };
  const closeEditPerformanceFrom = async () => {
    setShowPerformanceForm(false);
    setSongId(null);
  };

  const [fileDownloadRespMsg, setFileDownloadRespMsg] = useState('');
  const { fetchData: fetchPerformanceCsv, data: csvresp, hasFetched: csvhasFetched } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/performances/downloadperformancecsv`,
    method: "POST",
  });
  useEffect(() => {
    if(csvhasFetched){
      if(csvresp?.result){
        const buffer = Buffer.from(csvresp?.result);
        const blob = new Blob([buffer]);
        if (blob instanceof Blob){
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", csvresp?.name);
          document.body.appendChild(link);
          link.click();
          console.log("CSV Download Succesfuly.");
          setFileDownloadRespMsg('File download successfully.');
        }else{
          setFileDownloadRespMsg('Error while download file.');
          console.log("CSV Download: error on script side.");
        }
      }else{
        console.log("CSV Download: error on server side.");
        setFileDownloadRespMsg('File not found.');
      }
      
    }else{
      setFileDownloadRespMsg('');
    }
  }, [csvhasFetched]);

  const {
    fetchData,
    data: performances,
    errorContent,
    isLoading,
    hasFetched,
  } = useFetch({
    url: `${
      import.meta.env.VITE_API_URL
    }/performances/byfield?field=event_id&value=${event_id}`,
    method: "GET",
  });

  const [flagSelectedType, setflagSelectedType] = useState(true);
  useEffect(() => {
    //if (event_id) {
    if ( !hasFetched) {
      fetchData();
    } else {
      if ( flagSelectedType ) {
        setflagSelectedType(false);
        setSelectedType (performances?.eventDetails?.performance_type?.toUpperCase() || 'TWD');
        setSelectedSubType (performances?.eventDetails?.performance_subtype || '');
      }
      setSelectedEventId(performances.eventDetails?.id);
      setSelectedCompetitionId(performances.competition?.id);
      if (Array.isArray(performances?.songs.songs)) setSongs(performances.songs.songs);
    }
  }, [hasFetched, fetchData, performances, flagSelectedType]);

  if (errorContent) return errorContent;

  if (!hasFetched) {
    return null; // Prevent rendering until fetch is complete
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setSelectedFile(file);
  };


  const validateCsvFile = (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = ({ target }) => {
      if (!target?.result) return resolve("Error: Unable to read file");

      const csvContent = target.result as string;
      const rows = csvContent.split("\n").map(row => row.trim());
      if (rows.length < 2) return resolve("Invalid CSV: No data found");

      const parseCsvRow = (row: string) => {
        return row.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/).map(value =>
          value.replace(/^"|"$/g, "").trim()
        );
      };      

      const headers = parseCsvRow(rows[0]);
      const performanceTypeIndex = headers.indexOf("performance_type");
      // ADD THIS after other header indexes
      
      const songIdIndex = headers.indexOf("song_id");

      //console.log(headers,headers.indexOf("entry"));return;
      const entryNumberIndex = headers.indexOf("entry"); // Assuming 'entry_number' column
      const timeIndex = headers.indexOf("time"); // Assuming 'time' column exists in your CSV

      const divisionIndex = headers.indexOf("division");
      const programIndex = headers.indexOf("program");
      const colorCodeIndex = headers.indexOf("color_code");

      const performers_nameIndex = headers.indexOf("performers_name"); //for sds field  performers_name only empty validation
      const performersIndex = headers.indexOf("performers");
      const routineIndex = headers.indexOf("routine");
      const playlistIndex = headers.indexOf("playlist");
      const classIndex = headers.indexOf("class");
      const styleIndex = headers.indexOf("style");
      //const gradeIndex = headers.indexOf("grade");
      //const levelIndex = headers.indexOf("level");
      
      if (performanceTypeIndex === -1) return resolve("Invalid CSV: 'performance_type' column missing");

      const errors: string[] = [];

      const timeRegex = /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;

      rows.slice(1).forEach((row, rowIndex) => {
        const columns = parseCsvRow(row);
        const performanceType = columns[performanceTypeIndex] || "";        

        const song_id = songIdIndex !== -1 ? columns[songIdIndex] : "";

        const entryNumber = entryNumberIndex !== -1 ? columns[entryNumberIndex]: "";

        if (entryNumber && !song_id) {
          errors.push(`Error: Row number '${rowIndex + 2}' Entry ${entryNumber} requires a song_id (song_id is missing)`);
        }

        const division = divisionIndex !== -1 ? columns[divisionIndex]: "";
        const program = programIndex !== -1 ? columns[programIndex]: "";
        const colorCode = colorCodeIndex !== -1 ? columns[colorCodeIndex]: "";

        const performers_name = performers_nameIndex !== -1 ? columns[performers_nameIndex]: "";

        const performers_count = performersIndex !== -1 ? columns[performersIndex]: "";
        const routine = routineIndex !== -1 ? columns[routineIndex]: "";
        const playlist = playlistIndex !== -1 ? columns[playlistIndex]: "";
        const p_class = classIndex !== -1 ? columns[classIndex]: "";
        const style = styleIndex !== -1 ? columns[styleIndex]: "";
        //const grade = gradeIndex !== -1 ? columns[gradeIndex]: "";
        //const level = levelIndex !== -1 ? columns[levelIndex]: "";

        //console.log("entryNumber", entryNumber, columns[entryNumberIndex]);
        
        const time = timeIndex !== -1 ? columns[timeIndex] : "";

        if ( entryNumber !== "") {
          //let selected_type = (selectedType === "TWD_SHOWCASE") ? "TWD" : selectedType;
          if (!performanceType) {
            errors.push(`Error: Performance Type is empty at Entry ${entryNumber}`);
          } else if (!["TWD", "SDS"].includes(performanceType.toUpperCase())) {
            errors.push(`Error: Invalid Performance Type '${performanceType}' at Entry ${entryNumber}`);
          } else if (selectedType.toLowerCase() !== performanceType.toLowerCase()) {
            errors.push(`Error: Mismatch between selected type (${selectedType}${(selectedSubType==='showcase' ? "_SHOWCASE":"")}) and CSV performance type (${performanceType}) at Entry ${entryNumber}`);
          }
        }
          // Validate time format
          if (time && !timeRegex.test(time)) {
            errors.push(`Error: Invalid time format '${time}' at Entry ${entryNumber}. Expected format is HH:MM:SS`);
          }

            //validate empty fields -- time,entry,division,performers_name (for SDS only),program,color_code,performance_type
            let mandatoryFields = {};
            if ( performanceType === "twd" ) {
             mandatoryFields = { time: time, division: division, entry: entryNumber, program: program, color_code: colorCode, performace_type: performanceType, performers: performers_count, routine: routine, playlist: playlist, class: p_class, style: style, song_id: song_id };
            } else {
              mandatoryFields = { time: time, performers_name: performers_name }; //No additional fields should be added to this list to avoid replacing null or empty values.
            }
            let mandatoryfieldvalues = "";
            Object.entries(mandatoryFields).forEach( ([fieldname, fieldvalue]) => {
              if ( !fieldvalue ) {
                mandatoryfieldvalues += (mandatoryfieldvalues == '') ? `Error: Row number '${rowIndex + 2}' has empty fields ['${fieldname}'` : `, '${fieldname}'`;
              }            
            });
            if(mandatoryfieldvalues !='') mandatoryfieldvalues += `]`;
            if(mandatoryfieldvalues !='') errors.push(mandatoryfieldvalues);

      });

      if (errors.length > 0) return resolve(errors.join("\n"));

      resolve(null); // No errors
    };

    reader.onerror = () => reject("Error reading file");
    reader.readAsText(file);
    });
  };
  
  const handleCsvFileUpload = async (e: React.FormEvent) => {
    e.preventDefault();
  
    if (isUploadingCsv) {
      return;
    }
    if (!selectedFile) {
      return setErrorMessage("Please select a file first");
    }
  
    // Validate CSV file before uploading
    const validationError = await validateCsvFile(selectedFile);
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }
  
    const formData = new FormData();
    formData.append("performances", selectedFile);
    formData.append("competition_id", selectedCompetitionId);
    formData.append("event_id", selectedEventId);
    formData.append("performance_type", selectedType);
    formData.append("performance_subtype", selectedSubType);
  
    const token = localStorage.getItem("token");
    if (!token) throw new Error("No token found");
  
    try {
      setIsUploadingCsv(true);
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/admin/setperformanceswithcsv`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );
  
      const result = await response.json();
  
      if (response.ok) {
        setSelectedFile(null);
        setSuccessMessage(result.message);
        setSuccesPerformanceCount(result.data.successful_count);
        setSuccessPerformances(result.data.successful.join(", "));
        setFailedPerformanceCount(result.data.failed_count);
        setFailedPerformances(result.data.failed.join(", "));
        setShowResponsePopup(true);
        fetchData();
      } else {
          const errorMessage = formatTable(result?.details?.incorrect_programs);
          setErrorMessage(result.message !== undefined
            ? `${result.message}\n${result.error}\n${errorMessage}`
            : `${result.error?.error_message}`);
        
      }
    } catch (error) {
      setErrorMessage("Error occurred during file upload:");
      console.log("errorrrR: ",error);
      
    }
    setIsUploadingCsv(false);
  };  

  const formatTable = (data: any) => {
    if (!data || data.length === 0) return "No data available";
  
    // Create the header row
    const headers = Object.keys(data[0]).join(" | ");
  
    // Create rows for each object
    const rows = data.map((item: any) => 
      Object.values(item).map((value) => value ?? "null").join(" | ")
    );
  
    // Combine header and rows with new lines
    return [headers, ...rows].join("\n");
  };
  //if (error) return <p>Error: {error}</p>;

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;

  return (
    <>
      {showResponsePopup ? (
        <div className="response-popup-bg">
          <div className="response-popup">
            <div
              className="response-popup__closeBox cursor-pointer"
              onClick={() => setShowResponsePopup(false)}
            >
              <img
                src="./images/close-icon.svg"
                className="response-popup__closeIcon"
              />
            </div>
            <div>
              <h3 className="response-popup__heading">{successMessage}</h3>
              <div className="response-popup__sucessBox">
                <div>Successfully uploaded: {succesPerformanceCount}</div>
                <div className="leading-normal">
                  Entry numbers: {successPerformances}
                </div>
              </div>
              <div className="response-popup__failedBox">
                <div>Failed: {failedPerformanceCount}</div>
                <div>{failedPerformances}</div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      
      {(currentRole=="1" ? (
      <div className="form-container">
      <h2 style={{ fontSize: "24px" }}>Upload performances CSV.</h2>

      <label style={{ fontWeight: "normal" }}>Event Performance Type:</label>
      
          
  <div className="radio-scoring-container">
  
  <div className="radio-buttons-container">
  <label className="radio-label">
    <input
      type="radio"
      name="eventType"
      value="TWD"
      checked={selectedType === "TWD" && selectedSubType === ""}
      onChange={() => { setSelectedType("TWD"); setSelectedSubType(""); }}
      disabled={ (performances?.eventDetails?.performance_type!=null) && !(performances?.eventDetails?.performance_type === "twd" && performances?.eventDetails?.performance_subtype !== "showcase")}
    />
    <span>TWD</span>
    <a
      href="https://docs.google.com/spreadsheets/d/1OBeLJXngz17Ni77X3dNus_AW7v3Lf2MSIbXk9JobtYE/edit?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
      style={{ marginLeft: "25px" }}
    >
      Sample TWD CSV
    </a>
  </label>

  <label className="radio-label">
    <input
      type="radio"
      name="eventType"
      value="SDS"
      checked={selectedType === "SDS" && selectedSubType === ""}
      onChange={() => { setSelectedType("SDS"); setSelectedSubType(""); }}
      disabled={ (performances?.eventDetails?.performance_type!=null) && !(performances?.eventDetails?.performance_type === "sds" && performances?.eventDetails?.performance_subtype !== "showcase")}
    />
    <span>SDS</span>
    <a
      href="https://docs.google.com/spreadsheets/d/1nsE6YkQDlexwEOjw05RPSbOuhRs0JjB_nMZa5ztc--Q/edit?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
      style={{ marginLeft: "25px" }}
    >
      Sample SDS CSV
    </a>
  </label>

  <label className="radio-label">
    <input
      type="radio"
      name="eventType"
      value="TWD_SHOWCASE"
      checked={selectedType === "TWD" && selectedSubType === "showcase"}
      onChange={() => { setSelectedType("TWD"); setSelectedSubType("showcase"); }}
      disabled={ (performances?.eventDetails?.performance_type!=null) && !(performances?.eventDetails?.performance_type === "twd" && performances?.eventDetails?.performance_subtype === "showcase")}
    />
    <span>TWD Nationals</span>
    <a
      href="https://docs.google.com/spreadsheets/d/1OBeLJXngz17Ni77X3dNus_AW7v3Lf2MSIbXk9JobtYE/edit?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
      style={{ marginLeft: "25px" }}
    >
      Sample TWD Nationals CSV
    </a>
  </label>

  <label className="radio-label">
    <input
      type="radio"
      name="eventType"
      value="SDS_SHOWCASE"
      checked={selectedType === "SDS" && selectedSubType === "showcase"}
      onChange={() => { setSelectedType("SDS"); setSelectedSubType("showcase"); }}
      disabled={ (performances?.eventDetails?.performance_type!=null) && !(performances?.eventDetails?.performance_type === "sds" && performances?.eventDetails?.performance_subtype === "showcase")}
    />
    <span>SDS Nationals</span>
    <a
      href="https://docs.google.com/spreadsheets/d/1nsE6YkQDlexwEOjw05RPSbOuhRs0JjB_nMZa5ztc--Q/edit?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
      style={{ marginLeft: "25px" }}
    >
      Sample SDS Nationals CSV
    </a>
  </label>
</div>

  <div className="scoring-flow-container">
    {selectedType && (
      <div style={{ border: "1px dashed #ccc", borderRadius: "8px" }}>
        <label className="scoring-flow-label">
        Final Placement Ranking:
        </label>
        {selectedSubType === "showcase" ? (
          <div className="scoring-flow-text">
            Rank points (with high and low removed) ➔ <br />
            Rank points (with high and low added) ➔ <br />
            Total points (with high and low removed) ➔ <br />
            Total points (with high and low added) ➔ <br />
            Technique total points ➔ <br />
            Execution total points
          </div>
        ) : (
          <div className="scoring-flow-text">
            Total points (with high and low removed) ➔ <br />
            Total points (with high and low added) ➔ <br />
            Technique total points ➔ <br />
            Execution total points
          </div>
        )}
      </div>
    )}
  </div>
</div>

{/* File Upload Form */}
<EntityAddUpdateForm handleUserSubmit={handleCsvFileUpload}>
  <input
    type="file"
    onChange={handleFileChange}
    disabled={isUploadingCsv}
  />
</EntityAddUpdateForm>


      {errorMessage && (
        <p style={{ color: "red" }} dangerouslySetInnerHTML={{ __html: errorMessage.replace(/\n/g, "<br>") }} />
      )}
    </div>
      ) : null )}

      <section className="headersection2">
        <div className="w-layout-blockcontainer container-main-content w-container">
          <div className="div-header-title-section">
            <div
              className="link-block w-inline-block cursor-pointer"
              onClick={() =>
                navigate(`/events/${performances?.competition?.id}`)
              }
            >
              <img
                src="/images/back-icon.png"
                loading="lazy"
                alt=""
                className="image-2"
              />
              <h1 className="back-text-link">
                {performances?.competition?.title}
              </h1>
            </div>
            <h1 className="judgingapp-heading2">
              {performances?.eventDetails?.location}
            </h1>
            <p className="paragraph-2">
              {performances?.eventDetails?.event_date}
            </p>
          </div>
        </div>
      </section>
      <section style={{backgroundColor: 'white'}}>
        <div className="performance-container">
          {isLoading ? (
            <OneLineCardSkeleton
              cardsCount={2}
              baseColor="#d3ddf3"
              highlightColor="#fff"
            />
          ) : (
            <div className="performance-table">
              {((currentRole=="1" && performances?.performances?.length>0 ) ? (
              <div style={{ padding: '10px 0px 5px 0px', color: '#4545ff', textAlign: 'right', marginRight:'40px' }}>
                <span style={{ cursor: 'pointer'}} onClick={ 
                  async () =>  {
                    await fetchPerformanceCsv({filename:performances?.performances[0]?.source_temp_tablename}) 
                    } 
                  }
                >
                  <FileDownload style={{ verticalAlign: 'bottom' }}>  </FileDownload> Download original CSV
                </span><br/>
                <span style={{ display: 'none'}}>{ fileDownloadRespMsg }</span>
              </div>
              ) :null)}

            {((currentRole=="1" && performances?.performances?.length>0 ) ? (
              <div style={{ padding: '10px 0px 5px 0px', color: '#4545ff', textAlign: 'right', marginRight:'40px' }}>
                <button className='w-button' onClick={ 
                  async () =>  {
                    await AddPerformanceForm();
                    } 
                  }>Add performance</button>
              </div>
              ) :null)}

              {(currentRole == "1" && showPerformanceForm) ? (
                <section className="form-container add-edit-performance" ref={myRef} >
                  <h2 style={{ fontSize: "24px" }}>
                    {(newPerformanceData.isNew) ? `Add Performance` : `Edit Performance #${newPerformanceData.entry_number}`}
                  </h2>
                  <EntityAddUpdateForm
                    handleUserSubmit={ handleEditPerformance }
                    handleCancel={ closeEditPerformanceFrom }
                    isUpdateActive={true}
                  >
                    <div className="top-row">
                      <div>
                        <label>Entry Number</label>
                        { (newPerformanceData.isNew) ? (
                          <TextInput value={String(newPerformanceData.entry_number)}  type="number" placeholder="" 
                          onChange={(e) => { setNewPerformanceData((prev) => ({
                            ...prev,
                            entry_number: Number(e.target.value),
                          })) 
                        }} />
                        ): (
                          <div style={{margin:'5px 0', padding:'10px'}}>{newPerformanceData.entry_number}</div>
                        )}
                      </div>
                      <div style={{minWidth: '120px'}}>
                        <label>Time</label>
                        <TextInput value={newPerformanceData.performance_time}  type="time" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            performance_time: e.target.value,
                          })) 
                        }} />
                      </div>
                      <div>
                        <label>Division</label>
                        <SelectInput value={newPerformanceData.divisions_performance_groups_id} 
                        options={performances?.divisionlist.map((divs: any) => ({ value: divs.id, label: divs.title, }))} 
                        name="division" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            divisions_performance_groups_id: Number(e.target.value),
                          })) 
                         }} />
                      </div>
                      <div>
                        <label>Director</label>
                        <SelectInput value={newPerformanceData.user_programdirector_id} 
                        options={performances?.directorlist.map((divs: any) => ({ value: divs.id, label: divs.first_name, }))} 
                        name="director" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            user_programdirector_id: Number(e.target.value),
                          })) 
                         }} />
                      </div>
                      <div>
                        <label>Routine</label>
                        <TextInput value={newPerformanceData.routine}  type="text" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            routine: e.target.value,
                          })) 
                         }} />
                      </div>
                      <div>
                        <label>Playlist</label>
                        <TextInput value={newPerformanceData.playlist_number}  type="number" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            playlist_number: e.target.value,
                          })) 
                         }} />
                      </div>
                      {(performances?.eventDetails?.performance_type === 'twd') ? (
                      <div>
                        <label>Style</label>
                        <TextInput value={newPerformanceData.style}  type="text" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            style: e.target.value,
                          }))
                         }} />
                      </div>
                      ) : (null)}
                      {(performances?.eventDetails?.performance_type === 'twd') ? (
                      <div>
                        <label>Class</label>
                        <TextInput value={newPerformanceData.class}  type="text" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            class: e.target.value,
                          }))
                         }} />
                      </div>
                      ) : (null)}
                       {(performances?.eventDetails?.performance_type === 'twd') ? (
                      <div>
                        <label>Performers Count</label>
                        <TextInput value={newPerformanceData.performers_count}  type="number" placeholder="" 
                          onChange={(e) => { 
                            setNewPerformanceData((prev) => ({
                              ...prev,
                              performers_count: e.target.value,
                            }))
                           }} />
                      </div>
                      ) : (null)}
                      {(performances?.eventDetails?.performance_type === 'sds') ? (
                      <div>
                        <label>Grade</label>
                        <TextInput value={newPerformanceData.grade}  type="text" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            grade: e.target.value,
                          }))
                         }} />
                      </div>
                      ) : (null)}
                      {(performances?.eventDetails?.performance_type === 'sds') ? (
                      <div>
                        <label>Level</label>
                        <TextInput value={newPerformanceData.level}  type="text" placeholder="" 
                        onChange={(e) => { 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            level: e.target.value,
                          }))
                         }} />
                      </div>
                      ) : (null)}
                      <div>
                      <label>Description</label>
                        <textarea onChange={(e) => 
                          setNewPerformanceData((prev) => ({
                            ...prev,
                            description: e.target.value,
                          }))
                        } value={newPerformanceData.description}></textarea>
                      </div>
                      <div className="song-select-wrapper">
                        <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", fontSize: "13px" }}>
                          <span>Enter SongID or 0 to detach</span>
                          <a
                            href={`/music/${event_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              fontSize: "12px",
                              color: "#4545ff",
                              textDecoration: "none"
                            }}
                          >
                            Add Song ID
                          </a>
                        </label>
                        <SongSelect
                          songs={songs}
                          songId={songId}
                          eventId={event_id}
                          setSongId={setSongId}                          
                          setNewPerformanceData={setNewPerformanceData}
                        />
                          
                      </div>
                      {(performances?.eventDetails?.performance_type === 'sds') ? (
                      <div style={{ gridColumn: '1/5'}}>
                        <label>Performers</label>
                        <TagInput placeholder="Add Performer" tags={newPerformanceData.performerslistArr} setTags={setPerformancePerformers} /> 
                      </div>
                      ) : (null)}
                    </div>
                  </EntityAddUpdateForm>
                </section>
              ) : null}

              <div className="performance-table-row-performance-admin performance-table-header">
                <div className="item-1">Entry</div>
                <div className="item-2">Division <span className="separator"><br/></span><span className="program-text">Program/Performer</span></div>
                <div className="item-3">Total - PP </div>
                <div className="item-4">Routine</div>
                <div className="item-5">Playlist:<br/>SongID</div>
                {(performances.eventDetails.performance_type === "twd" || performances.eventDetails.performance_type == null) && (
                  <div className="item-6" style={{ marginLeft: '15px' }}>Style</div>
                )}
                {(currentRole=="1" &&
                <div className="item-6"></div>
                )}
                <div className="item-7"></div>
              </div>
              {performances?.performances?.map((performance: any) => {
                //const performanceColor = performance?.color_code === 1 ? "performance--yellow" : "performance--grey";
                const performanceColor = performances?.settings_color_code?.value?.[performance.performance_type][performance.color_code];
                return (
                  <PerformanceCard
                    key={performance.id}
                    id={performance.id}
                    type={"admin"}
                    performanceColor={performanceColor}
                    event_id={performance?.event_id}
                    entry_number={performance?.entry_number}
                    division={performance?.divisions_performance_group?.title}
                    performance_type={performance?.performance_type}
                    performers={performance?.performers}
                    program={performance?.programdirector?.first_name}
                    routine={performance?.routine?.routine}
                    secondLastColumn={performance?.playlist_number}
                    lastColumn={performance?.danceStyle?.style_title}
                    is_editing_allowed={false}
                    //ranking_final_score={performance?.Rankings[0]?.final_scores}
                    ranking_final_score={performance?.final_scores}
                    fetchData={fetchData}
                    showEditPerformanceForm={showEditPerformanceForm}
                    division_id={performance?.divisions_performance_group?.id}
                    routine_id={performance?.routine_id}
                    user_programdirector_id={performance?.user_programdirector_id}
                    performance_time={performance?.performance_time}
                    playlist_number={performance?.playlist_number}
                    song_id={performance?.song_id}
                    style={performance?.danceStyle?.style_title}
                    pclass={performance?.class?.name}
                    grade={performance?.grade}
                    level={performance?.level}
                    performer_count={performance?.performers_count}
                    description={performance?.description}
                    pdivisionStatus={performance?.divisions_performance_group?.status}
                    edit_delete_allowed={performance?.is_editing_allowed}
                    talktape={performance?.talktape}
                  />
                );
              })}
            </div>
          )}
        </div><br/>
      </section>
      <ConfirmActionDialog
        open={confirmDialog.open}
        action={confirmDialog.action}
        entryNumber={confirmDialog.entryNumber}
        meta={confirmDialog.meta}
        onConfirm={confirmDialog.onConfirm}
        onCancel={() => setConfirmDialog(p => ({ ...p, open: false }))}
      />
    </>
  );
};

export default AdminPerformances;